import { Navigation, Autoplay, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import CustomArrow from '@/components/arrow/index';

const list = [
  // {
  //   url: '//static.szlcsc.com/ecp/assets/newWeb/smt/banner/banner1.png',
  //   href: 'https://www.jlc.com/portal/t7i37578.html',
  //   alt: 'PCB免费打样 全国包邮',
  // },
  // {
  //   url: '//static.szlcsc.com/ecp/assets/newWeb/smt/banner/banner2.png',
  //   href: 'https://www.jlcsmt.com/order',
  //   alt: '嘉立创SMT在线下单',
  // },
  {
    url: '//static.szlcsc.com/ecp/assets/newWeb/smt/banner/banner3.jpg',
    // href: 'https://www.jlc.com/portal/q7i41881.html',
    alt: 'PCB多高层选嘉立创',
  },
  // {
  //   url: '//static.szlcsc.com/ecp/assets/newWeb/smt/banner/banner4.jpg',
  //   href: 'https://www.jlc.com/portal/q7i43691.html',
  //   alt: '嘉立创推出大批量“灵活浮动阶梯价”',
  // },
];

const BannerItem = ({ item }) => {
  return item.href ? (
    <a href={item.href} target="_blank" rel="noreferrer" ignore-spm>
      <img src={item.url} className="h-[500px] w-full object-cover" alt={item.alt} />
    </a>
  ) : (
    <img src={item.url} className="h-[500px] w-full object-cover" alt={item.alt} />
  );
};

const Banner = () => {
  return (
    <div className="custom-group relative h-[100%] w-full">
      <Swiper
        className="bannerSwiper hover:static"
        pagination={{
          clickable: true,
        }}
        autoplay={{
          delay: 5000,
        }}
        navigation={{
          nextEl: '#custom-next-button',
          prevEl: '#custom-prev-button',
        }}
        loop
        modules={[Navigation, Autoplay, Pagination]}
      >
        {list.map((item, index) => (
          <SwiperSlide key={index}>
            {index === 0 ? (
              <h1 aria-label={item.alt}>
                <BannerItem item={item} />
              </h1>
            ) : (
              <h2 aria-label={item.alt}>
                <BannerItem item={item} />
              </h2>
            )}
          </SwiperSlide>
        ))}
        {/* 自定义箭头 */}
        {list.length > 1 && <CustomArrow width={40} isInner={true} />}
      </Swiper>
    </div>
  );
};
export default Banner;
